export default __webpack_public_path__ + "static/media/logo_white.aa8bbd1a.png";